import * as i0 from '@angular/core';
import { Injectable, Component, NgModule, InjectionToken, inject, Inject } from '@angular/core';
import * as i1 from 'keycloak-angular';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ApptemplateLibModule, LoggingService, MCdialogService, LoadingIndicator } from 'mclane-apptemplate-lib';
import { CommonModule, Location } from '@angular/common';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, from, lastValueFrom, throwError, timer } from 'rxjs';
import { filter, take, switchMap, mergeMap, map, finalize, timeout, retryWhen } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as i2$1 from '@angular/router';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

class MclaneWebauthLibService {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class MclaneWebauthLibComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.4", type: MclaneWebauthLibComponent, selector: "lib-mclane-keycloak-lib", ngImport: i0, template: `
    <p>
    </p>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-mclane-keycloak-lib', template: `
    <p>
    </p>
  ` }]
        }] });

class MclaneWebauthLibModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibModule, declarations: [MclaneWebauthLibComponent], imports: [KeycloakAngularModule, ApptemplateLibModule], exports: [MclaneWebauthLibComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibModule, imports: [KeycloakAngularModule, ApptemplateLibModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: MclaneWebauthLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MclaneWebauthLibComponent],
                    imports: [KeycloakAngularModule, ApptemplateLibModule
                    ],
                    exports: [MclaneWebauthLibComponent]
                }]
        }] });

class NoAccessComponent {
    path;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: NoAccessComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.4", type: NoAccessComponent, selector: "app-no-access", ngImport: i0, template: "<h2 style=\"display: flex; font-size: x-large; justify-content: center;\">\r\n    Access Denied. Please contact McLane Helpdesk.\r\n</h2>\r\n" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: NoAccessComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-no-access", template: "<h2 style=\"display: flex; font-size: x-large; justify-content: center;\">\r\n    Access Denied. Please contact McLane Helpdesk.\r\n</h2>\r\n" }]
        }] });

const WEBAUTHENVIRONMENTER = new InjectionToken('WebAuthEnvironmenter');

/* tslint:disable:variable-name */
class JwtService {
    environmentInjection;
    console = inject(LoggingService);
    get token() {
        return this._token;
    }
    set token(value) {
        this._token = value;
    }
    get roles() {
        return this._roles;
    }
    set roles(value) {
        this._roles = value;
    }
    get preferred_username() {
        return this._preferred_username;
    }
    set preferred_username(value) {
        this._preferred_username = value;
    }
    _preferred_username;
    _roles;
    _decoder = new JwtHelperService();
    _token = '';
    _loggedIn = false;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    isLoggedIn() {
        return this.token !== '';
    }
    getJwt(token) {
        return this._decoder.decodeToken(token);
    }
    setJwt(token) {
        this.token = token;
        try {
            const decoded = this._decoder.decodeToken(token);
            // Checks if preferred_username token claim exist
            if (decoded.hasOwnProperty('preferred_username')) {
                this.preferred_username = decoded.preferred_username;
            }
            // Checks if given token claim and user roles exist
            const roleName = this.environmentInjection.roleCheck.toString();
            if (roleName == null) {
                this.console.error('Please set roleCheck in your environment.ts');
                return;
            }
            const accountRoles = decoded.resource_access[roleName];
            if (accountRoles == null) {
                this.roles = [];
            }
            else {
                this.roles = accountRoles.roles;
            }
        }
        catch (e) {
            this.console.error(`Sorry could not set token: ${e.message}`);
        }
    }
    getJwtAttribute(attributeName) {
        const decoded = this._decoder.decodeToken(this.token);
        try {
            return decoded[attributeName];
        }
        catch (e) {
            this.console.log('No jwt attribute found');
            return null;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: JwtService, deps: [{ token: WEBAUTHENVIRONMENTER }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: JwtService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: JwtService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WEBAUTHENVIRONMENTER]
                }] }] });

class AuthInterceptorService {
    keycloakService = inject(KeycloakService);
    _jwtService = inject(JwtService);
    constructor() { }
    decoder = new JwtHelperService();
    _refreshTokenInProgress = false;
    _refreshTokenSubject = new BehaviorSubject(null);
    intercept(request, next) {
        if (!this._refreshTokenInProgress) {
            console.log('Refreshing Token');
            this._refreshTokenInProgress = true;
            this._refreshTokenSubject.next(null);
            return this.requestAccessToken(request, next);
        }
        else {
            return this._refreshTokenSubject.pipe(filter(result => result !== null), take(1), switchMap((res) => {
                return next.handle(this.tokenHttpHeaders(request));
            }));
        }
    }
    tokenHttpHeaders(request) {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this._jwtService.token}`,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        });
        return request.clone({ headers });
    }
    requestAccessToken(request, next) {
        return from(this.keycloakService.getToken()).pipe(mergeMap(token => {
            this._jwtService.setJwt(token);
            this._refreshTokenSubject.next(token);
            this._refreshTokenInProgress = false;
            return next.handle(this.tokenHttpHeaders(request));
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInterceptorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInterceptorService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInterceptorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class CookieManagementService {
    cookieService = inject(CookieService);
    constructor() { }
    setCookie(options, deleteDuplicate = false) {
        try {
            if (deleteDuplicate) {
                this.deleteCookie(options.name);
            }
            else {
                if (this.checkCookieExists(options.name)) {
                    console.warn('Cookie Already exists, make sure you set deleteDuplicate');
                }
            }
            this.cookieService
                .set(options.name, options.value, 13, options.path, options.domain, false, options.sameSite);
        }
        catch (e) {
            console.log(e);
        }
    }
    getCookie(name) {
        return this.cookieService.get(name);
    }
    getAllCookies() {
        return this.cookieService.getAll();
    }
    checkCookieExists(name) {
        return this.cookieService.check(name);
    }
    deleteCookie(name) {
        return this.cookieService.delete(name);
    }
    changeCookie(options) {
    }
    extendCookieTime(name) {
        if (this.checkCookieExists(name)) {
            this.getCookie(name);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: CookieManagementService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: CookieManagementService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: CookieManagementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

/* tslint:disable:object-literal-shorthand */
class HttpClientService {
    _httpClient = inject(HttpClient);
    get defaultHeaders() {
        return this._defaultHeaders;
    }
    set defaultHeaders(value) {
        this._defaultHeaders = value;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    set baseUrl(value) {
        this._baseUrl = value;
    }
    // tslint:disable-next-line:variable-name
    _baseUrl;
    // tslint:disable-next-line:variable-name
    _defaultHeaders;
    // tslint:disable-next-line:variable-name
    constructor() {
    }
    getData(endpoint, headers, responseType = 'text') {
        return this._httpClient
            // @ts-ignore
            .get(`${this.baseUrl}/${endpoint}`, { headers: headers, observe: 'body', responseType: 'json', withCredentials: true, })
            .pipe(map((unknown) => { unknown = unknown; }));
    }
    postData(endpoint, body, headers, responseType = 'json') {
        let bodyJson;
        const HTTPOptions = {
            headers: headers,
            responseType: responseType,
            withCredentials: true,
            observe: 'response'
        };
        if (body != null) {
            bodyJson = JSON.stringify(body);
        }
        return this._httpClient
            .post(`${this.baseUrl}/${endpoint}`, bodyJson, HTTPOptions);
    }
    combineDefaultandCallHeaders(headers) {
        const combinedHeaders = new HttpHeaders();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: HttpClientService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: HttpClientService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: HttpClientService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class ChallengeService {
    httpClientService;
    httpClient;
    environmentInjection;
    // tslint:disable-next-line:variable-name
    _httpClient;
    defaultHeaders;
    baseUrl;
    constructor(httpClientService, httpClient, environmentInjection) {
        this.httpClientService = httpClientService;
        this.httpClient = httpClient;
        this.environmentInjection = environmentInjection;
        this._httpClient = httpClient;
        this.baseUrl = environmentInjection.supportServicePrefix;
        console.log(this.baseUrl);
        this.defaultHeaders = new HttpHeaders().append('X-Requested-With', 'XmlHttpRequest').append('Content-Type', 'application/json');
        this.httpClientService.defaultHeaders = this.defaultHeaders;
        this.httpClientService.baseUrl = this.baseUrl;
    }
    getChallengeImages() {
        if (this.baseUrl == null) {
            console.error('Please Add supportServicePrefix property to your environment');
        }
        else {
            return this.httpClient.get(this.baseUrl + '/fs-connect-support-ws/rest/v1/challenge/question', { headers: this.defaultHeaders, observe: 'response', withCredentials: true });
        }
    }
    postAnswer(answer) {
        if (this.baseUrl == null) {
            console.error('Please Add supportServicePrefix property to your environment');
        }
        else {
            return this.httpClient
                .post(this.baseUrl + '/fs-connect-support-ws/rest/v1/challenge/answer', answer, { headers: this.defaultHeaders, observe: 'response', responseType: 'text', withCredentials: true });
        }
    }
    postAuthResponse(authToken) {
        return this.httpClientService.postData('challenge/authResponse', authToken, this.httpClientService.defaultHeaders, 'text');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeService, deps: [{ token: HttpClientService }, { token: i2.HttpClient }, { token: WEBAUTHENVIRONMENTER }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: HttpClientService }, { type: i2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WEBAUTHENVIRONMENTER]
                }] }] });

class OauthService {
    environmentInjection;
    jwtService = inject(JwtService);
    keycloakService = inject(KeycloakService);
    cookieManService = inject(CookieManagementService);
    challengeService = inject(ChallengeService);
    console = inject(LoggingService);
    httpClient = inject(HttpClient);
    googleAuthToken = 'challengeResponseToken';
    idpCookieName = 'mcco-idpHint';
    deviceAuth = 'mcc_challenge_complete';
    // tslint:disable-next-line:variable-name
    _httpClient;
    defaultHeaders;
    baseUrl;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
        console.log(this.baseUrl);
        this.defaultHeaders = new HttpHeaders().append('X-Requested-With', 'XmlHttpRequest').append('Content-Type', 'application/json');
    }
    isLoggedIn() {
        return this.jwtService.isLoggedIn();
    }
    loginExtended(login) {
        if (login.idpHint != null && login.idpHint !== '') {
            return this.keycloakService.login({ idpHint: login.idpHint });
        }
        else if (login.useCookieIdp && login.cookieIdpName) {
            if (this.cookieManService.checkCookieExists(login.cookieIdpName)) {
                const hint = this.cookieManService.getCookie(login.cookieIdpName);
                return this.keycloakService.login({ idpHint: hint });
            }
            else {
                this.console.log('Cookie Does Not Exist defaulting to regular login');
                return this.keycloakService.login();
            }
        }
        else {
            return this.keycloakService.login();
        }
    }
    getApplicationEnvironment() {
        const env = this.environmentInjection.buildEnv;
        if (env == null) {
            this.console.error('Please add app_env (PROD, UAT, DEV, LOCAL) to your environment');
            return null;
        }
        return env.toUpperCase();
    }
    logoutOfApplication(redirectUri) {
        const href = window.location.href.toString();
        if (this.cookieManService.checkCookieExists(this.deviceAuth)) {
            this.cookieManService.deleteCookie(this.deviceAuth);
        }
        this.serverLogout().then(() => {
            this.keycloakService.logout(redirectUri).then(() => window.location.href = href);
        }).catch((errors) => {
            this.console.log(errors);
            this.keycloakService.logout(redirectUri).then(() => window.location.href = href);
        });
    }
    async serverLogout() {
        const baseUrl = this.environmentInjection.supportServicePrefix;
        return this.httpClient.delete(`${baseUrl}/challenge/users/allUserCookies`, { headers: this.defaultHeaders, responseType: 'text' }).toPromise();
    }
    async bootstrapServerAuth(token) {
        if (token == null || token === '') {
            this.console.error(`No auth token found`);
            return;
        }
        let authResponse;
        authResponse = { token };
        return await lastValueFrom(this.challengeService.postAuthResponse(authResponse)).then().catch((er) => this.console.error(er));
    }
    tryGetIdpCookie() {
        if (this.cookieManService.checkCookieExists(this.idpCookieName)) {
            const idpHint = this.cookieManService.getCookie(this.idpCookieName);
            if (idpHint !== '' || idpHint != null) {
                return idpHint;
            }
            else {
                return '';
            }
        }
    }
    extendDate(date, daysToExtend = 5) {
        return date.setDate(date.getDate() + daysToExtend);
    }
    checkGoogleAuthCookie() {
        if (this.cookieManService.checkCookieExists(this.googleAuthToken)) {
            return this.cookieManService.getCookie(this.googleAuthToken);
        }
        else {
            return '';
        }
    }
    deviceAuthCookieExists(environment) {
        return this.cookieManService.checkCookieExists(`${this.deviceAuth}_${environment}`);
    }
    getAllCookies() {
        return this.cookieManService.getAllCookies();
    }
    setDeviceAuthCookie() {
        try {
            this.cookieManService.setCookie({ name: `${this.deviceAuth}_LOCAL`, expires: this.extendDate(new Date()), value: 'true', sameSite: 'Lax' }, true);
        }
        catch (e) {
            this.console.log(e);
        }
    }
    setIdpHintCookie() {
        try {
            const prof = this.keycloakService.getKeycloakInstance().profile;
            if (prof != null) {
                // @ts-ignore
                const att = prof.attributes;
                if (att.hasOwnProperty('kc_idp_hint')) {
                    const hint = att.kc_idp_hint;
                    const separatedHintArray = hint[0].split('=');
                    const lastItem = separatedHintArray.length - 1;
                    const currentHint = separatedHintArray[lastItem];
                    const expirationDate = this.extendDate(new Date(), 7);
                    this.cookieManService.setCookie({ name: 'mcco-idphint', value: currentHint, secure: true,
                        sameSite: 'Strict', domain: '', path: '', expires: expirationDate }, true);
                }
            }
            return true;
        }
        catch (e) {
            this.console.error(e);
            return false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: OauthService, deps: [{ token: WEBAUTHENVIRONMENTER }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: OauthService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: OauthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WEBAUTHENVIRONMENTER]
                }] }] });

class AuthServicesService {
    // tslint:disable-next-line:variable-name
    _keycloakService;
    // tslint:disable-next-line:variable-name
    _oauthService;
    constructor(keycloakService, oauthService) {
        this._oauthService = oauthService;
        this._keycloakService = keycloakService;
    }
    getUsername() {
        return this._keycloakService.getUsername();
    }
    async getToken() {
        return await this._keycloakService.getToken();
    }
    async logout(redirectUri) {
        await this._keycloakService.logout(redirectUri);
    }
    async getUserRoles() {
        return this._keycloakService.getUserRoles();
    }
    async LoggedIn() {
        return await this._keycloakService.isLoggedIn();
    }
    async CheckUserRole(role, resource) {
        return this._keycloakService.isUserInRole(role, resource);
    }
    async isTokenValid() {
        return await this._keycloakService.isTokenExpired();
    }
    async addTokenToHeader() {
        return await this._keycloakService.addTokenToHeader();
    }
    async addSopher() {
        return null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthServicesService, deps: [{ token: i1.KeycloakService }, { token: OauthService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthServicesService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthServicesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.KeycloakService }, { type: OauthService }] });

class RetryInterceptorService {
    environmentInjection;
    authService = inject(AuthServicesService);
    router = inject(Router);
    dialogs = inject(MCdialogService);
    loadingIndicator = inject(LoadingIndicator);
    isCalled = false;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    intercept(request, next) {
        const genericRetryStrategy = ({ maxRetryAttempts = 2, scalingDuration = 2000, excludedStatusCodes = [] } = {}) => (attempts) => {
            let errorStatus;
            return attempts.pipe(mergeMap((error, i) => {
                console.log(error);
                errorStatus = error.status;
                if (errorStatus === 0) {
                    return;
                }
                else if (errorStatus === 400 || errorStatus === 403 || errorStatus === 409 || errorStatus === 500) {
                    return throwError(() => error);
                }
                else if (errorStatus === 401) {
                    const retryAttempt = i + 1;
                    if (retryAttempt <= maxRetryAttempts) {
                        this.dialogs.showToastError('401 - Missing or invalid authentication token. Retrying request...', '401 Unauthorized');
                    }
                    if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
                        return throwError(() => error);
                    }
                }
                else if (errorStatus === 404) {
                    const retryAttempt = i + 1;
                    if (retryAttempt <= maxRetryAttempts) {
                        this.dialogs.showToastError('404 - The server has not found anything matching the Request-URI. Retrying request...', '404 Not Found');
                    }
                    if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
                        return throwError(() => error);
                    }
                }
                else if (errorStatus === 462) {
                    if (!this.isCalled) {
                        this.dialogs.showToastError('The server has rejected your access token, please contact helpdesk or try clearing cache and using a new browser', '462 Error in API Cookie');
                        this.isCalled = true;
                    }
                    return throwError(() => error);
                }
                else if (errorStatus === 463) {
                    if (!this.isCalled) {
                        this.dialogs.showToastError('Missing required header, please contact helpdesk or try clearing cache and using a new browser', '463 Missing required header');
                        this.isCalled = true;
                    }
                    return throwError(() => error);
                }
                else {
                    const retryAttempt = i + 1;
                    if (retryAttempt <= maxRetryAttempts) {
                        this.dialogs.showToastError('Connection Error! Attempt ' + retryAttempt.toString() + ': Retrying request in ' + scalingDuration.toString()
                            .slice(0, 1) + ' seconds.', '');
                    }
                    if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
                        return throwError(() => error);
                    }
                }
                return timer(scalingDuration);
            }), finalize(() => {
                if (errorStatus === 401) {
                    const keycloakInstance = this.authService._keycloakService.getKeycloakInstance().clientId;
                    this.dialogs.showConfirmDialogOkOnly('User Session Expired', 'Your user session has expired. Please log back in').then(async () => {
                        await this.authService.logout(this.environmentInjection.BASEURL + '/home');
                    });
                }
                else if (errorStatus === 400) {
                    this.dialogs.showToastError('400 - The request cannot be fulfilled due to bad syntax.', 'Error ' + errorStatus);
                    this.removeLoadingIndicator();
                }
                else if (errorStatus === 403) {
                    this.dialogs.showToastError('403 - User not authorized to perform the operation or the resource is unavailable for some reason', 'Error ' + errorStatus);
                    this.removeLoadingIndicator();
                }
                else if (errorStatus === 404) {
                    this.dialogs.showToastError('404 - The requested resource could not be found but may be available again in the future. ', 'Error ' + errorStatus);
                    this.removeLoadingIndicator();
                }
                else if (errorStatus === 409) {
                    this.dialogs.showToastError('409 - The request could not be completed due to a conflict with the current state of the resource.', 'Error ' + errorStatus);
                    this.removeLoadingIndicator();
                }
                else if (errorStatus === 462) {
                    if (this.loadingIndicator.isLoading) {
                        this.loadingIndicator.hide();
                    }
                    this.router.navigate(['/access-denied']).then(async () => {
                    });
                }
                else if (errorStatus === 463) {
                    if (this.loadingIndicator.isLoading) {
                        this.loadingIndicator.hide();
                    }
                    this.router.navigate(['/access-denied']).then(() => {
                    });
                }
                else if (errorStatus === 500) {
                    if (this.loadingIndicator.isLoading) {
                        this.loadingIndicator.hide();
                    }
                    this.router.navigate(['/500']).then(() => {
                    });
                }
                else {
                    if (this.loadingIndicator.isLoading) {
                        this.loadingIndicator.hide();
                    }
                    this.router.navigate([this.router.url]).then(() => {
                    });
                }
            }));
        };
        return next.handle(request).pipe(timeout(15000), retryWhen(genericRetryStrategy()));
    }
    removeLoadingIndicator() {
        if (this.loadingIndicator.loaderActive) {
            this.loadingIndicator.loaderActive = false;
            this.loadingIndicator.hide();
        }
        if (this.loadingIndicator.isLoading) {
            this.loadingIndicator.hide();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: RetryInterceptorService, deps: [{ token: WEBAUTHENVIRONMENTER }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: RetryInterceptorService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: RetryInterceptorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WEBAUTHENVIRONMENTER]
                }] }] });

class AuthenticationModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthenticationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.4", ngImport: i0, type: AuthenticationModule, declarations: [NoAccessComponent], imports: [CommonModule, KeycloakAngularModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthenticationModule, providers: [AuthInterceptorService, RetryInterceptorService], imports: [CommonModule, KeycloakAngularModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthenticationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NoAccessComponent],
                    imports: [CommonModule, KeycloakAngularModule],
                    providers: [AuthInterceptorService, RetryInterceptorService],
                    exports: [],
                }]
        }] });

const AuthGuard = (route, state) => {
    const keycloakAngular = inject(KeycloakService);
    const oauthService = inject(OauthService);
    const jwtService = inject(JwtService);
    const router = inject(Router);
    let granted = false;
    const result = keycloakAngular.isLoggedIn();
    if (!result) {
        const cookie = oauthService.tryGetIdpCookie();
        oauthService.loginExtended({
            useCookieIdp: true,
            cookieIdpName: oauthService.idpCookieName,
        });
        return false;
    }
    else {
        keycloakAngular.getToken().then(async (token) => {
            jwtService.setJwt(token);
            console.log("Token Refreshed!");
        });
    }
    const requiredRoles = route.data.roles;
    if (!requiredRoles || requiredRoles.length === 0) {
        granted = true;
    }
    else {
        for (const requiredRole of requiredRoles) {
            if (jwtService.roles.indexOf(requiredRole) > -1) {
                granted = true;
                break;
            }
        }
    }
    if (granted === false) {
        router.navigate(["/access-denied"]).then();
    }
    return true;
};

class AuthInit {
    keycloakService;
    router;
    // tslint:disable-next-line:variable-name
    _keycloak;
    authenticated;
    constructor(keycloakService, router) {
        this.keycloakService = keycloakService;
        this.router = router;
        this._keycloak = keycloakService;
    }
    initializer(options, router) {
        if (options.onLoad == null || options.onLoad === '') {
            options.onLoad = 'login-required';
        }
        if (options.authConfig == null || options.authConfig === '') {
            console.log('No Authentication settings set please make sure you have set "authConfig"');
            return;
        }
        return new Promise(async (resolve, reject) => {
            try {
                await this._keycloak.init({
                    config: options.authConfig,
                    initOptions: {
                        onLoad: options.onLoad,
                        checkLoginIframe: options.checkIframe
                    },
                    bearerExcludedUrls: options.excludedUrls,
                });
                resolve(null);
            }
            catch (error) {
                console.log(error);
                reject(error);
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInit, deps: [{ token: i1.KeycloakService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInit, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: AuthInit, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.KeycloakService }, { type: i2$1.Router }] });

class ChallengeComponent {
    environmentInjection;
    oauthService = inject(OauthService);
    router = inject(Router);
    recaptchaService = inject(ReCaptchaV3Service);
    location = inject(Location);
    console = inject(LoggingService);
    // public environmentInjection = inject(WEBAUTHENVIRONMENTER);
    errorText;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    ngOnInit() {
        if (this.oauthService.deviceAuthCookieExists(this.oauthService.getApplicationEnvironment())) {
            this.router.navigateByUrl("/").then();
            return;
        }
        this.executeImportantAction();
    }
    checkChallenge(token) {
        this.oauthService.bootstrapServerAuth(token).then((result) => {
            const env = this.oauthService.getApplicationEnvironment();
            if (env == null) {
                return null;
            }
            let isValidResponse = false;
            if (typeof result == 'string') {
                if (result.includes("Your User Response Token is valid")) {
                    isValidResponse = true;
                }
                else {
                    console.error("Unexpected text response:", result);
                }
            }
            else {
                const responseObj = result;
                if (responseObj && responseObj.ok) {
                    isValidResponse = true;
                }
                else {
                    console.error("Unexpected Json response:", result);
                }
            }
            // let response = result as unknown;
            // let responseObj = response as HttpResponse<JSON>;
            if (isValidResponse) {
                if (this.environmentInjection.localhostDev === true) {
                    this.oauthService.setDeviceAuthCookie();
                }
                if (this.oauthService.deviceAuthCookieExists(this.oauthService.getApplicationEnvironment())) {
                    this.location.back();
                }
                else {
                    this.console.error("No Cookies were found");
                }
            }
        }).catch((error) => {
            console.error("Error in checkChallenge:", error);
        });
    }
    executeImportantAction() {
        lastValueFrom(this.recaptchaService.execute("UserCheck"))
            .then((token) => {
            this.checkChallenge(token);
        })
            .catch((error) => {
            this.console.error(error);
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeComponent, deps: [{ token: WEBAUTHENVIRONMENTER }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.4", type: ChallengeComponent, selector: "lib-challenge", ngImport: i0, template: "<div class=\"challengeHolder\">\r\n  <div class=\"informationDiv\">\r\n    <h2 class=\"vCheckText\">Please wait while we perform a verification check</h2>\r\n    <div class=\"loader\">Loading...</div>\r\n  </div>\r\n</div>\r\n", styles: [".challengeHolder{width:100vw;height:100vh;position:absolute;display:flex;background-color:#000;opacity:.7;flex-direction:column;justify-content:center;align-items:center;top:0;left:0}.challengeHolder .informationDiv{width:400px;height:400px;background-color:#005bbb;display:flex;flex-direction:column;justify-content:center;align-items:center}.challengeHolder .informationDiv .vCheckText{text-align:center;color:#fff}.loader{color:#fff;font-size:20px;margin:100px auto;width:1em;height:1em;border-radius:50%;position:relative;text-indent:-9999em;-webkit-animation:load4 1.3s infinite linear;animation:load4 1.3s infinite linear;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}@-webkit-keyframes load4{0%,to{box-shadow:0 -3em 0 .2em,2em -2em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em}12.5%{box-shadow:0 -3em,2em -2em 0 .2em,3em 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em,3em 0 0 .2em,2em 2em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0,2em 2em 0 .2em,0 3em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em,0 3em 0 .2em,-2em 2em,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em,-2em 2em 0 .2em,-3em 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0 0 .2em,-2em -2em}87.5%{box-shadow:0 -3em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0,-2em -2em 0 .2em}}@keyframes load4{0%,to{box-shadow:0 -3em 0 .2em,2em -2em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em}12.5%{box-shadow:0 -3em,2em -2em 0 .2em,3em 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em,3em 0 0 .2em,2em 2em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0,2em 2em 0 .2em,0 3em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em,0 3em 0 .2em,-2em 2em,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em,-2em 2em 0 .2em,-3em 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0 0 .2em,-2em -2em}87.5%{box-shadow:0 -3em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0,-2em -2em 0 .2em}}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-challenge", template: "<div class=\"challengeHolder\">\r\n  <div class=\"informationDiv\">\r\n    <h2 class=\"vCheckText\">Please wait while we perform a verification check</h2>\r\n    <div class=\"loader\">Loading...</div>\r\n  </div>\r\n</div>\r\n", styles: [".challengeHolder{width:100vw;height:100vh;position:absolute;display:flex;background-color:#000;opacity:.7;flex-direction:column;justify-content:center;align-items:center;top:0;left:0}.challengeHolder .informationDiv{width:400px;height:400px;background-color:#005bbb;display:flex;flex-direction:column;justify-content:center;align-items:center}.challengeHolder .informationDiv .vCheckText{text-align:center;color:#fff}.loader{color:#fff;font-size:20px;margin:100px auto;width:1em;height:1em;border-radius:50%;position:relative;text-indent:-9999em;-webkit-animation:load4 1.3s infinite linear;animation:load4 1.3s infinite linear;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}@-webkit-keyframes load4{0%,to{box-shadow:0 -3em 0 .2em,2em -2em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em}12.5%{box-shadow:0 -3em,2em -2em 0 .2em,3em 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em,3em 0 0 .2em,2em 2em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0,2em 2em 0 .2em,0 3em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em,0 3em 0 .2em,-2em 2em,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em,-2em 2em 0 .2em,-3em 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0 0 .2em,-2em -2em}87.5%{box-shadow:0 -3em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0,-2em -2em 0 .2em}}@keyframes load4{0%,to{box-shadow:0 -3em 0 .2em,2em -2em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em}12.5%{box-shadow:0 -3em,2em -2em 0 .2em,3em 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em,3em 0 0 .2em,2em 2em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0,2em 2em 0 .2em,0 3em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em,0 3em 0 .2em,-2em 2em,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em,-2em 2em 0 .2em,-3em 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0 0 .2em,-2em -2em}87.5%{box-shadow:0 -3em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em,-3em 0,-2em -2em 0 .2em}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WEBAUTHENVIRONMENTER]
                }] }] });

class ChallengeModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.4", ngImport: i0, type: ChallengeModule, declarations: [ChallengeComponent], imports: [CommonModule], exports: [ChallengeComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeModule, providers: [
            ChallengeService,
            CookieManagementService,
            OauthService,
            HttpClientService,
        ], imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.4", ngImport: i0, type: ChallengeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ChallengeComponent
                    ],
                    imports: [
                        CommonModule,
                    ],
                    providers: [
                        ChallengeService,
                        CookieManagementService,
                        OauthService,
                        HttpClientService,
                    ],
                    exports: [
                        ChallengeComponent
                    ]
                }]
        }] });

const ChallengeGuard = (route, state) => {
    const oauthService = inject(OauthService);
    const router = inject(Router);
    if (!oauthService.deviceAuthCookieExists(oauthService.getApplicationEnvironment())) {
        router.navigateByUrl("/challenge").then((r) => { });
        return false;
    }
    return true;
};

/*
 * Public API Surface of mclane-keycloak-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthGuard, AuthInit, AuthInterceptorService, AuthServicesService, AuthenticationModule, ChallengeComponent, ChallengeGuard, ChallengeModule, ChallengeService, CookieManagementService, HttpClientService, JwtService, MclaneWebauthLibComponent, MclaneWebauthLibModule, MclaneWebauthLibService, NoAccessComponent, OauthService, RetryInterceptorService, WEBAUTHENVIRONMENTER };
